import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { Subscription } from 'rxjs';
import { RequestService } from '../../services/requests.services';

@Component({
  selector: 'app-request-statistics',
  templateUrl: './request-statistics.component.html',
  styleUrls: ['./request-statistics.component.css']
})
export class RequestStatisticsComponent implements OnInit, OnDestroy {
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  @Input() requestId: number | undefined;
  reviewersList: any;
  isListloading = false;
  reviewersSubscription?: Subscription;

  constructor(private readonly requestService: RequestService) {
  }
  ngOnDestroy(): void {
    this.reviewersSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.getRequestReviewers(Number(this.requestId));
  }

  getRequestReviewers(id: number) {
    this.isListloading = true;
    this.reviewersSubscription = this.requestService.getrequestReviewers(id).subscribe({
      next: (response: any) => {
        this.reviewersList = response;
      },
      error: (error: any) => {
        console.log(error)
      },
      complete: () => { this.isListloading = false; }
    });
  }
}
